import React, { useCallback, useContext } from "react";
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { RootStoreContext } from "src/stores/RootStore";
import { ColorStyle } from "src/utils/Colors";
import styles from "./AiExtractionInProgressModal.module.css";

const AiExtractionInProgressModalBase = () => {
    const { t } = useTranslation();
    const { invoiceFilePreviewStore } = useContext(RootStoreContext);

    // Closing the modal only dismisses the UI — the /ai-detect-with-file request
    // keeps running in the background and its result will still be applied to the
    // form when it comes back.
    const handleClose = useCallback(() => {
        invoiceFilePreviewStore.setIsAiExtractionModalDismissed(true);
    }, [invoiceFilePreviewStore]);

    const show = invoiceFilePreviewStore.isAiPending && !invoiceFilePreviewStore.isAiExtractionModalDismissed;

    return (
        <UI.Modal size="md" show={show} onClose={handleClose} centered={true}>
            <div className={styles.AiExtractionModalBody}>
                <div className={styles.AiSparklePulse}>
                    <UI.Icon icon={UI.SVGIcon.AiSparkle} size={100} color={ColorStyle("primary")} />
                </div>
                <div className={styles.AiExtractionModalText}>{t("screens.kredi_flow.ai.extracting_data")}</div>
            </div>
        </UI.Modal>
    );
};

export const AiExtractionInProgressModal = Sentry.withProfiler(observer(AiExtractionInProgressModalBase));
